export default "__VITE_ASSET__3poWexQ3__"